export class FeatureTypes {
    public static Custom: string = 'Custom';
    public static Import: string = 'Import';
}